import '@css/bestcosme/common.scss'
import '@css/bestcosme/2026_half.scss'

$(document).ready(function () {
  $('.anchor_link').click(function (event) {
    event.preventDefault();
    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top
    }, 500, 'swing');
  });

  const $halfProductRoot = $('#half_product_owl_carousel');
  const $halfProductCarousel = $('#half_product_owl_carousel .js_half_product_owl_carousel');
  if ($halfProductCarousel.length > 0) {
    const syncHalfProductNewstarCta = function (event) {
      let hrefs = $halfProductRoot.data('newstarCtaHrefs');
      if (typeof hrefs === 'string') {
        try {
          hrefs = JSON.parse(hrefs);
        } catch (e) {
          return;
        }
      }
      const $cta = $('#half_product_newstar_cta');
      if (!$cta.length || !Array.isArray(hrefs) || !hrefs.length) {
        return;
      }

      const owl = (event && event.relatedTarget) || $halfProductCarousel.data('owl.carousel');
      let idx;
      if (owl && typeof owl.relative === 'function' && typeof owl.current === 'function') {
        idx = owl.relative(owl.current());
      } else {
        const $center = $halfProductRoot.find('.owl-item.center .award-slider-item');
        const slide = parseInt($center.data('productSlide'), 10);
        idx = Number.isFinite(slide) ? slide - 1 : 0;
      }

      if (!Number.isFinite(idx) || idx < 0 || idx >= hrefs.length) {
        return;
      }
      $cta.attr('href', hrefs[idx]);
    };

    const halfProductSliderOwl = $halfProductCarousel.owlCarousel({
      loop: true,
      margin: 0,
      nav: false,
      dots: false,
      center: true,
      autoplayTimeout: 4000,
      autoplayHoverPause: true,
      items: 3
    });
    halfProductSliderOwl.on('changed.owl.carousel', function (e) {
      syncHalfProductNewstarCta(e);
    });
    halfProductSliderOwl.on('initialized.owl.carousel', function (e) {
      window.setTimeout(function () {
        syncHalfProductNewstarCta(e);
      }, 0);
    });

    $('#half_product_owl_carousel .slidesjs-next').click(function () {
      halfProductSliderOwl.trigger('next.owl.carousel');
    });
    $('#half_product_owl_carousel .slidesjs-previous').click(function () {
      halfProductSliderOwl.trigger('prev.owl.carousel', [300]);
    });
  }

  $('.bestcosme-half-feature-hotnews').each(function () {
    const $root = $(this);
    const $owl = $root.find('.js_half_feature_hotnews_owl');
    if ($owl.length === 0) {
      return;
    }
    const hotnewsOwl = $owl.owlCarousel({
      loop: true,
      margin: 0,
      nav: false,
      dots: false,
      center: true,
      autoplayTimeout: 4000,
      autoplayHoverPause: true,
      items: 3
    });
    $root.find('.slidesjs-next').on('click', function () {
      hotnewsOwl.trigger('next.owl.carousel');
    });
    $root.find('.slidesjs-previous').on('click', function () {
      hotnewsOwl.trigger('prev.owl.carousel', [300]);
    });
  });
});
